import { useMetaIntegration } from './system/status.js';
import './deployment.css';

export const DeploymentNotice = () => {
  const { enabled, checkEnabled } = useMetaIntegration();
  if (enabled === true) return null;
  return <aside className="deployment-notice" aria-label="Estado da integração Meta">
    <strong>{enabled === false ? 'Configuração da Meta pendente' : 'Integração Meta não confirmada'}</strong>
    <p>O painel está disponível para consulta. Conexões, alterações em campanhas e webhooks permanecem bloqueados até a configuração autorizada da Meta. Nenhuma mensagem é enviada neste modo.</p>
    <button type="button" onClick={() => void checkEnabled()}>Verificar integração novamente</button>
  </aside>;
};
